import React, { useLayoutEffect, useRef, useState } from 'react'

import GetImage from 'components/functional/getImage'

import Arrow from 'svgs/cast-arrow.svg'
import CloseIcon from 'svgs/close.svg'
import { gsap } from 'gsap'

export default function SingleCast({
  data,
  index,
  bioOpen,
  setBioOpen,
  setDesktopCast,
}) {
  const { name, role, image, bio } = data
  const [open, setOpen] = useState(false)
  const target = useRef()
  const tl = useRef()
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      tl.current = gsap
        .timeline()
        .to(target.current, {
          display: 'block',
          height: 'auto',
          opacity: 1,
        })
        .to('.fade', {
          opacity: 1,
        })
    }, target)
  }, [])
  useLayoutEffect(() => {
    if (!open) {
      tl.current.timeScale(2)
      tl.current.reverse()
    } else {
      tl.current.timeScale(1)
      tl.current.play()
    }
  }, [open])

  const handleClick = index => {
    setOpen(true)
    window.location.hash = `#${index}`
  }
  const handleDesktopBioOpen = name => {
    setDesktopCast(data)
    setBioOpen(true)
    window.location.hash = `#${name}`
  }
  return (
    <>
      <div
        className="relative z-10 text-center space-y-2 bg-black w-full cursor-pointer"
        onClick={() => handleDesktopBioOpen(name)}
      >
        <div className="w-[90%] mx-auto">
          <GetImage data={image} alt={`${name} | Add Site Name`} />
          <h5 className="text-lg font-bold">{name}</h5>
          <div dangerouslySetInnerHTML={{ __html: role }} />
          <div
            className={`cast-icon text-center flex items-center justify-center ${
              open && 'icon-active'
            }  `}
          >
            <Arrow className="md:hidden" onClick={() => handleClick(index)} />
            <Arrow
              className="hidden md:block"
              onClick={() => handleDesktopBioOpen(name)}
            />
          </div>
        </div>
      </div>
      <div
        className="relative bg-white z-0 w-full opacity-0 h-[0px] hidden md:hidden md:invisible"
        ref={target}
      >
        <div className="absolute top-[-3rem] " id={index} />
        <div className=" bg-white py-8 text-center">
          <div
            className="blockTextStyling w-[90%] mx-auto fade"
            dangerouslySetInnerHTML={{ __html: bio }}
          />
          <div className="text-center mx-auto close-icon">
            <CloseIcon onClick={() => setOpen(!open)} />
          </div>
        </div>
      </div>
    </>
  )
}
